export default __webpack_public_path__ + "static/media/return-svgrepo-com.b7ce2c70.svg";